import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { forwardRef, Inject, Injectable } from '@angular/core';
import { from, Observable, of, switchMap, tap } from 'rxjs';
import { LOCALLY_HOSTED } from '../common/setup';
import { IndexedDBService } from './indexeddb.service';


@Injectable()
export class LocalNavigationInterceptor implements HttpInterceptor {

    constructor(@Inject(forwardRef(() => IndexedDBService)) private indexedDbService: IndexedDBService) { }


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq = req;
        if (!LOCALLY_HOSTED) {
            return next.handle(authReq);
        }
        if (req.method != 'GET') {
            return next.handle(authReq);
        }
        if (window.navigator.onLine) {
            return next.handle(req).pipe(
                tap((event) => {
                    if (event instanceof HttpResponse) {
                        this.indexedDbService.save(req.urlWithParams, event.body).catch(err => {

                            // retry if not initialized
                            if (err == IndexedDBService.DB_NOT_REFRENCED_ERROR) {
                                this.indexedDbService.init().then(() => this.indexedDbService.save(req.urlWithParams, event.body))
                                    .catch(err => console.error(err));
                            } else {
                                console.error(err);
                            }
                        });
                    }
                })
            );
        } else {
            return from(this.indexedDbService.get(req.urlWithParams)).pipe(
                switchMap(dbObject => of(new HttpResponse({ body: dbObject, status: 200 })))
            );
        }
    }
}

export const localNavigationInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: LocalNavigationInterceptor, multi: true }
];